"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = exports.EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = exports.DEFAULT_THROTTLE_RATE = 50;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/dist/constants.js
// module id = 54
// module chunks = 35783957827783 162898551421021 253626871324061